<template>
  <div>
    <Error v-if="error" variant="no-border" :message="customErrorMsg" />
    <div
      :class="[variance, { 'has-errors': error.length > 0 }]"
      class="custom-radio-buttom-container selector-control"
    >
      <div
        v-for="(item, index) in options"
        :key="'rbQuestion' + index"
        @click="checkButton(item.value)"
        class="d-flex"
      >
        <div
          class="page-item border-left"
          :class="{ 'bg-success': onApplyBackground(item) }"
        >
          <div
            class="d-flex flex-row-reverse radio-item custom-radio-buttom"
            :class="{
              'has-errors': error.length > 0,
              disabled: disabled,
              'border-top border-bottom rounded-top-left': index === 0,
              'border-bottom rounded-bottom-left': index === options.length - 1,
              'radio-item-unselected': !onApplyBackground(item),
              'border-bottom': !onApplyBackground(item),
              'radio-item-selected': onApplyBackground(item),
              'radio-item-selected-slot': onApplyBackground(item) && item.slot
            }"
          >
            <div class="input-group text-center">
              <input
                :id="`rbgInput${contextId}${index}`"
                v-model="model"
                type="radio"
                :disabled="disabled"
                :name="`rbgNumber${contextId}`"
                :value="item.value"
              />
              <div class="circle-checkmark d-flex justify-content-center">
                <div
                  class="checkmark align-self-center"
                  :class="{ 'bg-success': onApplyBackground(item) }"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class=" border-right w-100 radio-item-unselected border-bottom"
          :class="{
            'has-errors': error.length > 0,
            disabled: disabled,
            'border-top rounded-top-right': index === 0,
            'border-bottom rounded-bottom-left rounded-bottom-right':
              index === options.length - 1,
            'radio-item-label-selected': onApplyBackground(item),
            'd-flex justify-content-start align-items-center':
              !onApplyBackground(item) || !item.slot
          }"
        >
          <p
            class="font-14 mb-0 ml-2"
            :class="{
              'mt-3': onApplyBackground(item) && item.slot,
              'text-danger': error.length > 0
            }"
          >
            <span class="font-weight-bold">{{ item.title }} <span v-if="item.label">-</span> </span>
            {{ item.label }}
          </p>
          <div v-if="onApplyBackground(item)" class="mx-3">
            <slot :name="item.slot" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Error from "@/components/common/Error.vue";
export default {
  name: "CustomRadioQuestion",
  components: {
    Error
  },
  computed: {
    model: {
      get() {
        return this.value || null;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    onApplyBackground() {
      return item => {
        if (!this.model) return false;
        const result = item.value === this.model;
        return result;
      };
    }
  },
  props: {
    contextId: {
      type: Number,
      default: () => 1
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: () => null
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: "Estado Error",
        example: "Texto requerido"
      }
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: "Mensaje de error encontrado",
        example: "Texto requerido"
      }
    },
    variance: {
      type: String,
      default: () => new String()
    }
  },
  methods: {
    checkButton(value) {
      if (this.disabled === false) {
        this.model = value;
        this.$emit("change", value);
      }
    }
  }
};
</script>

<style scoped>
.custom-radio-buttom-container {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-right: 1px;
  margin-right: -10px;
  margin-top: 3px;
  margin-bottom: 0px;
}

.custom-radio-buttom-container input {
  visibility: hidden;
  position: absolute;
}

.custom-radio-buttom {
  background-color: transparent;
  width: 52px;
}

.custom-radio-buttom,
.custom-radio-buttom label,
.custom-radio-buttom input {
  cursor: pointer;
}

.custom-radio-buttom.disabled,
.custom-radio-buttom.disabled label,
.custom-radio-buttom.disabled input {
  cursor: default;
}

.disabled {
  background-color: #f8f8f8;
  cursor: not-allowed;
}

.circle-checkmark {
  border: 1px solid rgba(60, 60, 60, 0.26);
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-left: 3px;
  background: #fff;
}

.checkmark {
  height: 60%;
  width: 60%;
  border-radius: 50%;
}

.checkmark:after {
  content: "";
  display: none;
}

.custom-radio-buttom input:checked ~ .circle-checkmark > .checkmark {
  background: #2db782 !important;
}

.custom-radio-buttom-container.has-errors {
  border: 1px solid #c9545e;
  border-radius: 5px;
}

.custom-radio-buttom.has-errors {
  background-color: #ffebeb;
}

.radio-item {
  position: relative;
  display: block;
  padding: 1.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #2db782;
  background-color: #fff;
  border-left: 1px solid #dee2e6;
}
.radio-item-unselected {
  background: #f8f8f8;
}
.radio-item-selected {
  background: #2db782;
}
.radio-item-label-selected {
  background: #e8e8e8;
}

.rounded-top-left {
  border-top-left-radius: 0.25rem;
}
.rounded-top-right {
  border-top-right-radius: 0.25rem;
}
.rounded-bottom-left {
  border-bottom-left-radius: 0.25rem;
}
.rounded-bottom-right {
  border-bottom-right-radius: 0.25rem;
}
.radio-item-selected-slot {
  padding: 3.5rem 0.75rem;
}
</style>
